import { ChannelCardTestID, TextTestID } from "@/constants/TestID";
import { Avatar, FAIconName, Icon, Text } from "@/ui/core";
import MessagesAvatarGroup from "@/ui/core/MessagesAvatarGroup";
import { HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ChannelPreviewCardProps {
  channelName: string;
  channelUrl: string;
  description?: string;
  isGroupChannel?: boolean;
  members: BaseUserAvatarProps[];
}

const ChannelInformationCard = ({
  channelName,
  channelUrl,
  description,
  isGroupChannel,
  members,
}: ChannelPreviewCardProps) => {
  const baseTestID = joinTestIDs(
    channelUrl,
    "channel-preview",
    TextTestID.Card,
  );

  return (
    <HStack
      gap={16}
      paddingHorizontal={12}
      paddingVertical={10}
      testID={baseTestID}
      width="100%"
    >
      {isGroupChannel ? (
        <MessagesAvatarGroup testID={baseTestID} users={members} />
      ) : (
        <Avatar
          size="sm"
          testID={joinTestIDs(baseTestID, "avatar")}
          userName={channelName}
          userType="provider"
        />
      )}
      <VStack flex={1} gap={2}>
        <HStack alignItems="center" gap={6} overflow="hidden">
          {isGroupChannel && (
            <Icon
              name={FAIconName.UserGroupSolid}
              size="sm"
              testID={joinTestIDs(baseTestID, "group-channel")}
            />
          )}
          <Text
            color={ColorToken.NeutralPrimary}
            flexShrink={0}
            numberOfLines={1}
            testID={joinTestIDs(baseTestID, ChannelCardTestID.ChannelName)}
            variant="bodyMedium"
          >
            {channelName}
          </Text>
        </HStack>
        <HStack gap={6}>
          <Text
            color={ColorToken.NeutralSecondary}
            flexShrink={1}
            numberOfLines={1}
            testID={joinTestIDs(baseTestID, TextTestID.Description)}
            variant="caption"
          >
            {description}
          </Text>
        </HStack>
      </VStack>
    </HStack>
  );
};

export default ChannelInformationCard;
